import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { axiosInstance } from './config';

export const profileKeys = {
  all: ['profile'],
  details: () => [...profileKeys.all, 'details'],
};

// Internal API calls
const api = {
  getProfile: async () => {
    const { data } = await axiosInstance.get('/profiles');
    return data;
  },
  completeOnboarding: async (payload) => {
    const { data } = await axiosInstance.put('/profiles/onboarding', payload);
    return data;
  },
};

// Exported hooks
export const useProfile = () => {
  return useQuery({
    queryKey: profileKeys.details(),
    queryFn: api.getProfile,
  });
};

export const useCompleteOnboarding = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: api.completeOnboarding,
    onSuccess: (data) => {
      queryClient.setQueryData(profileKeys.details(), data);
    },
  });
};
 